import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * SPA page_view tracker.
 *
 * Google Consent Mode v2 handles the actual consent gating — gtag will send
 * either cookieless pings (before consent) or full events (after consent).
 * We just fire page_view on every route change.
 */
export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
